// AppTabs.js
import React, { useState, useEffect, useMemo } from "react";
import FyrionInicio from "./3dfyrioninicio";
import FyrionInicioProductos, { preloadProductos } from "./3dfyrioninicioproductos";
import FyrionInicioSimulacion from "./3dfyrioniniciosimulacion";
import { useNavigate } from "react-router-dom";

/**
 * AppTabs
 * - Mantiene montadas las 3 vistas.
 * - Oculta NO activas con display: "none" (evita overlays / fixed children que bloquean).
 * - Preload de productos en background llamando preloadProductos() exportado desde el módulo de productos.
 */
export default function AppTabs({ initial = "INICIO" }) {
  const navigate = useNavigate();

  const [view, setView] = useState(() => {
    const fromHash = typeof window !== "undefined" ? (window.location.hash?.replace("#", "") || null) : null;
    return fromHash ? fromHash.toUpperCase() : initial;
  });

  // Sincroniza hash
  useEffect(() => {
    try {
      window.history.replaceState(null, "", `#${view}`);
    } catch (e) {}
  }, [view]);

  // Lanzar precarga en background (no bloqueante)
  useEffect(() => {
    // Si la función preloadProductos existe, la llamamos
    if (typeof preloadProductos === "function") {
      // no await, solo arrancamos en background
      preloadProductos()
        .then((data) => {
          // opcional: log o acciones si lo deseas
          console.debug("AppTabs: productos precargados", Object.keys(data || {}).length);
        })
        .catch((err) => {
          console.warn("AppTabs: fallo precarga productos", err);
        });
    }
  }, []);

  // Botones de pestañas (memo para evitar re-render innecesario)
  const tabs = useMemo(() => ["INICIO", "PRODUCTOS", "SIMULADORES"], []);

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>


      {/* CONTENEDOR: las vistas están montadas siempre, pero las no activas usan display: none */}
      <div style={{ width: "100%", position: "relative" }}>
        {/* INICIO */}
        <div
          role="region"
          aria-hidden={view !== "INICIO"}
          style={{
            display: view === "INICIO" ? "block" : "none", // <- importante: display none para NO activas
            width: "100%",
            position: "relative",
            top: 0,
            left: 0,
          }}
        >
          <FyrionInicio setView={setView} navigate={navigate} />
        </div>

        {/* PRODUCTOS */}
        <div
          role="region"
          aria-hidden={view !== "PRODUCTOS"}
          style={{
            display: view === "PRODUCTOS" ? "block" : "none",
            width: "100%",
            position: "relative",
            top: 0,
            left: 0,
          }}
        >
          <FyrionInicioProductos setView={setView} navigate={navigate} />
        </div>

        {/* SIMULADORES */}
        <div
          role="region"
          aria-hidden={view !== "SIMULADORES"}
          style={{
            display: view === "SIMULADORES" ? "block" : "none",
            width: "100%",
            position: "relative",
            top: 0,
            left: 0,
          }}
        >
          <FyrionInicioSimulacion setView={setView} navigate={navigate} />
        </div>
      </div>
    </div>
  );
}
